module.exports = __webpack_public_path__ + "static/img/icon_amazon.583c09b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channelServices/icon_amazon.png
// module id = 4Rsd
// module chunks = 0